import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { LicenseFeature } from "src/app/shared/models/license-feature.model";
import { License } from "src/app/shared/models/license.model";
import { PrinterDeviceItem } from "src/app/shared/models/PrinterDevice.model";

@Component({
	selector: "app-kitchen-device-feature-setup",
	templateUrl: "./kitchen-device-feature-setup.component.html",
	styleUrls: ["../../../../../commandcenter.scss"],
})
export class KitchenDeviceFeatureSetupComponent implements OnInit {
	@Input() kitchenDevice: License;
	@Output() kitchenDeviceChange = new EventEmitter<License>();

	@Input() features: LicenseFeature;
	@Output() featuresChange = new EventEmitter<LicenseFeature>();

	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Input() printerDeviceList: PrinterDeviceItem[];
	@Output() printerDeviceListChange = new EventEmitter<PrinterDeviceItem>();

	licenseBumpFromDeviceList: number[] = [];

	constructor(public app: AppService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.licenseBumpFromDeviceList = this.kitchenDevice.features.bumpFromPrinterIdList.map((i) => +i);
	}

	kitchenDeviceBumpFromDeviceChange() {
		this.kitchenDevice.features.bumpFromPrinterIdList = this.licenseBumpFromDeviceList.map((i) => i);
		this.kitchenDeviceChange.emit(this.kitchenDevice);
		this.changesToSave = true;
		this.changesToSaveChange.emit(this.changesToSave);
	}
}
